import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useCheckout from "components/orders/hooks/useCheckout";
import { formatPrice, formatDate } from "utils";
import api from "api";
import { debug } from 'utils';
import OrderPaymentModal from "components/orders/modals/OrderPaymentModal";
import OrderDetailsModal from "components/orders/modals/OrderDetailsModal";
import SendPaymentLinkModal from "components/orders/modals/SendPaymentLinkModal";
import InvoiceBillingInfoModal from "components/orders/modals/InvoiceBillingInfoModal";
export default function CustomerOrders() {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [openId, setOpenId] = useState(null); // dropdown ouvert
  const checkout = useCheckout();
  const dropdownRefs = useRef({});
  const getOrders = async () => {
    try {
      api.handleError = false;
      const response = await api.get('/customer/orders');
      if (response.data) {
        setOrders(response.data);
      }
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getOrders();
  }, []);
  // fermeture click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      const refs = dropdownRefs.current;
      const isInside = Object.values(refs).some(ref =>
        ref && ref.contains(e.target)
      );
      if (!isInside) {
        setOpenId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // fermeture ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setOpenId(null);
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);





  if (isLoading) {
    return (
      <div className="small text-muted customer-orders text-center">
        Chargement en cours
      </div>
    );
  }
  if (orders.length === 0) {
    return (
      <div className="customer-orders text-center text-muted">
        Aucune commande trouvée
      </div>
    );
  }
  const handleDetails = (order) => {
    // navigate(`/orders/${order.orderId}`);
  };
  const handlePay = (order) => {
    // navigate(`/orders/${order.orderId}/pay`);
  };
  if (isLoading) {
    return (
      <div className="text-center text-muted small">
        Chargement en cours
      </div>
    );
  }
  const getPaymentStatusClass = (status) => {
    switch (status) {
      case "complete":
        return "text-primary";
      case "failed":
        return "text-danger";
      case "processing":
      case "pending":
        return "text-warning";
      default:
        return "text-muted";
    }
  };
  return (
    <div className="customer-orders">
      <div className="container">
        <div className="table-responsive pb-5" style={{ overflow: 'visible' }}>
          <table className="table table-sm table-striped align-middle mb-5">
            <thead className="table-light">
              <tr>
                <th>Numéro</th>
                <th>Date</th>
                <th>Total TTC</th>
                <th>Payé</th>
                <th>Solde</th>
                <th>Status</th>
                <th className="text-center" style={{ width: '140px' }}></th>
              </tr>
            </thead>
            <tbody>

              {orders.map((order) => (
                <tr key={order.orderId}>
                  <td className="text-center">
                    {order?.formatedInvoiceNumber ? (order.formatedInvoiceNumber) : '-'}
                  </td>
                  <td className="text-center">
                    {order.orderDate
                      ? formatDate(order.orderDate)
                      : "-"}
                  </td>
                  <td className="text-center">
                    {formatPrice(order.orderTotalPriceIT)}
                  </td>
                  <td className="text-center">
                    {formatPrice(order.orderTotalPaid)}
                  </td>
                  <td className="text-center">
                    <strong className={order.orderBalance > 0 ? "text-danger" : ""}>
                      {formatPrice(order.orderBalance)}
                    </strong>
                  </td>
                  <td className="text-center">
                    <span className={getPaymentStatusClass(order.orderPaymentStatus)}>
                      {t(`order_payment_status_${order.orderPaymentStatus}`)}
                    </span>
                  </td>
                  <td className="text-end">
                    <div
                      className="btn-group position-relative"
                      ref={(el) => (dropdownRefs.current[order.orderId] = el)}
                    >
                      {/* bouton principal */}
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => {
                          setOpenId(null);
                          setSelectedOrderId(order.orderId);
                        }}
                      >
                        Détails
                      </button>
                      {/* toggle */}
                      <button
                        className="btn btn-sm btn-outline-primary dropdown-toggle dropdown-toggle-split"
                        disabled={!['pending', 'failed'].includes(order.orderPaymentStatus)}
                        onClick={() =>
                          setOpenId(openId === order.orderId ? null : order.orderId)
                        }
                      />
                      {/* menu */}
                      {openId === order.orderId && (
                        <ul className="dropdown-menu show dropdown-menu-end">
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                setOpenId(null);
                                setSelectedOrderId(order.orderId);
                              }}
                            >
                              Détails
                            </button>
                          </li>
                          {['pending', 'failed'].includes(order.orderPaymentStatus) && (
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() => {
                                  setOpenId(null);
                                  checkout.setOrderId(order.orderId);
                                  checkout.startCheckout();
                                }}
                              >
                                Régler
                              </button>
                            </li>
                          )}
                          {['pending', 'failed'].includes(order.orderPaymentStatus) && (
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() => {
                                  setOpenId(null);
                                  checkout.setOrderId(order.orderId);
                                  checkout.startPaymentLink();

                                }}
                              >
                                Envoyer un lien de paiement
                              </button>
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {checkout.showBillingModal && (
        <InvoiceBillingInfoModal
          show={true}
          defaultValues={checkout.billingInfos}
          onClose={checkout.closeBilling}
          onSave={checkout.handleBillingSave}
          enableProfileInfo={true}
        />
      )}
      {checkout.showPaymentModal && (
        <OrderPaymentModal
          orderId={checkout.orderId}
          onClose={() => { getOrders(); checkout.closePayment(); }}
          onPaid={getOrders}
        />
      )}
      {checkout.showPaymentLinkModal === true && (
        <SendPaymentLinkModal
          orderId={checkout.orderId}
          onClose={checkout.closePaymentLink}
          onPaid={getOrders}
        />
      )}
      {selectedOrderId && (
        <OrderDetailsModal
          orderId={selectedOrderId}
          show={true}
          onClose={() => setSelectedOrderId(null)}
        />
      )}
    </div>
  );
}